import { render, staticRenderFns } from "./disclamer.vue?vue&type=template&id=d64108de&scoped=true&"
import script from "./disclamer.vue?vue&type=script&lang=js&"
export * from "./disclamer.vue?vue&type=script&lang=js&"
import style0 from "./disclamer.vue?vue&type=style&index=0&id=d64108de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64108de",
  null
  
)

component.options.__file = "disclamer.vue"
export default component.exports